// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import { ChevronRight, ExpandMore } from '@material-ui/icons';
import { TreeItem, TreeView } from '@material-ui/lab';
import { makeStyles, Typography, Box } from '@material-ui/core';

//Custom Components
import CustomButton from './CustomButton';

const useStyles = makeStyles((theme) => ({
	treeItem: {
		padding: theme.spacing(1.5),
		width: '100%',
	},
	childItem: {
		display: 'flex',
		alignItems: 'center',
		height: 50,
	},
}));

const SubItem = ({
	sItem,
	styles,
	onAddChild,
	onEditChild,
	onDeleteChild,
	onChangeStatus,
}) => {
	return (
		<TreeItem
			key={sItem.id}
			nodeId={`${sItem.id}`}
			label={
				<div className="d-flex justify-content-between">
					<Typography className="d-flex align-items-center" variant="subtitle2">
						{sItem.nombre}
					</Typography>
					<div className={styles}>
						<CustomButton
							key={`add-child-of${sItem.organoId}`}
							mainText="Agregar"
							color={sItem.estatus === 'I' ? 'light-dark' : 'light-primary'}
							onClick={(e) => {
								onAddChild(sItem);
							}}
							className="ml-2"
						/>
						<CustomButton
							key={`update-child-of${sItem.organoId}`}
							mainText="Editar"
							color={sItem.estatus === 'I' ? 'light-dark' : 'light-primary'}
							onClick={(e) => {
								onEditChild(sItem);
							}}
							className="ml-2"
						/>
						<CustomButton
							key={`delete-child-of${sItem.organoId}`}
							mainText="Borrar"
							color={sItem.estatus === 'I' ? 'light-dark' : 'light-primary'}
							onClick={(e) => {
								onDeleteChild(sItem);
							}}
							className="ml-2"
						/>
						<CustomButton
							key={`status-child-of${sItem.organoId}`}
							mainText={sItem.estatus === 'I' ? 'Activar' : 'Desactivar'}
							color={sItem.estatus === 'I' ? 'light-dark' : 'light-primary'}
							onClick={(e) => {
								onChangeStatus(sItem);
							}}
							className="ml-2"
						/>
					</div>
				</div>
			}
		>
			{sItem?.organos?.map((sItem) => (
				<SubItem
					sItem={sItem}
					styles={styles}
					key={sItem.id}
					onAddChild={onAddChild}
					onEditChild={onEditChild}
					onDeleteChild={onDeleteChild}
					onChangeStatus={onChangeStatus}
				/>
			))}
		</TreeItem>
	);
};

const TreeViewComponent = (props) => {
	const { items, onAddChild, onEditChild, onDeleteChild, onChangeStatus } = props;
	const classes = useStyles();

	return (
		<TreeView
			aria-label="file system navigator"
			defaultCollapseIcon={<ExpandMore />}
			defaultExpandIcon={<ChevronRight />}
		>
			{items?.map((item) => (
				<TreeItem
					className={classes.treeItem}
					key={item.id}
					nodeId={`${item.id}`}
					label={
						<div className="d-flex justify-content-between">
							<Typography
								className="d-flex align-items-center"
								variant="subtitle1"
							>
								{item.nombre}
							</Typography>
							<Box>
								<CustomButton
									key={`add-child-${item.id}`}
									mainText="Agregar"
									color={
										item.estatus === 'I'
											? 'light-dark'
											: 'light-primary'
									}
									onClick={(e) => {
										onAddChild(item);
									}}
									className="ml-2"
								/>
								<CustomButton
									key={`update-child-${item.id}`}
									mainText="Editar"
									color={
										item.estatus === 'I'
											? 'light-dark'
											: 'light-primary'
									}
									onClick={(e) => {
										onEditChild(item);
									}}
									className="ml-2"
								/>
								<CustomButton
									key={`delete-child-${item.id}`}
									mainText="Borrar"
									color={
										item.estatus === 'I'
											? 'light-dark'
											: 'light-primary'
									}
									onClick={(e) => {
										onDeleteChild(item);
									}}
									className="ml-2"
								/>
								<CustomButton
									key={`status-child-${item.id}`}
									mainText={
										item.estatus === 'I' ? 'Activar' : 'Desactivar'
									}
									color={
										item.estatus === 'I'
											? 'light-dark'
											: 'light-primary'
									}
									onClick={(e) => {
										onChangeStatus(item);
									}}
									className="ml-2"
								/>
							</Box>
						</div>
					}
				>
					{item?.organos?.map((sItem) => (
						<SubItem
							key={sItem.id}
							sItem={sItem}
							styles={classes.childItem}
							onAddChild={onAddChild}
							onEditChild={onEditChild}
							onDeleteChild={onDeleteChild}
							onChangeStatus={onChangeStatus}
						/>
					))}
				</TreeItem>
			))}
		</TreeView>
	);
};

TreeViewComponent.propTypes = {
	items: PropTypes.array.isRequired,
	onAddChild: PropTypes.func,
	onEditChild: PropTypes.func,
	onDeleteChild: PropTypes.func,
};

TreeViewComponent.defaultProps = {
	items: [],
	onAddChild: () => console.log('add child'),
	onEditChild: () => console.log('edit child'),
	onDeleteChild: () => console.log('delete child'),
};

export default TreeViewComponent;
